import { getCoupon } from './fixtures';

const DECLINED_CARD = '4000000000000002';

const attachInput = (selector, { placeholder, name }) => {
  const host = typeof selector === 'string'
    ? document.querySelector(selector)
    : selector;
  if (!host || host.querySelector('[data-recurly-mock]')) {
    return;
  }

  host.classList.add('recurly-element');

  const input = document.createElement('input');
  input.type = 'text';
  input.placeholder = placeholder;
  input.setAttribute('data-recurly-mock', name);
  input.setAttribute('aria-label', placeholder);
  input.autocomplete = 'off';
  input.style.cssText = [
    'width:100%',
    'background:transparent',
    'border:none',
    'color:#fff',
    'font:inherit',
    'outline:none'
  ].join(';');
  host.appendChild(input);
};

const readMockCardNumber = () => {
  if (typeof document === 'undefined') return '';
  return document.querySelector('[data-recurly-mock="number"]')?.value || '';
};

const createPricing = () => {
  const state = { coupon: { discount: null } };
  return {
    items: state,
    subscription: async () => undefined,
    coupon: async (code) => {
      const discount = getCoupon(code);
      if (!discount) {
        throw new Error('Could not find the requested coupon');
      }
      state.coupon = { discount };
    }
  };
};

export const createRecurlyMock = () => ({
  configure() {},
  Elements() {
    return {
      CardNumberElement: () => ({
        attach: (selector) => attachInput(selector, { placeholder: 'Card number', name: 'number' })
      }),
      CardMonthElement: () => ({
        attach: (selector) => attachInput(selector, { placeholder: 'MM', name: 'month' })
      }),
      CardYearElement: () => ({
        attach: (selector) => attachInput(selector, { placeholder: 'YYYY', name: 'year' })
      }),
      CardCvvElement: () => ({
        attach: (selector) => attachInput(selector, { placeholder: 'CVV', name: 'cvv' })
      })
    };
  },
  token(_elements, _form, callback) {
    const cardNumber = readMockCardNumber().replace(/\s/g, '');
    if (cardNumber === DECLINED_CARD) {
      callback({ message: 'Your card was declined.' }, null);
      return;
    }
    callback(null, { id: 'mock-recurly-card-token' });
  },
  bankAccount: {
    token(_form, callback) {
      callback(null, { id: 'mock-recurly-bank-token' });
    }
  },
  Pricing: {
    Checkout: () => createPricing(),
    Subscription: () => ({
      plan: async () => undefined
    })
  }
});

export const installRecurlyMock = () => {
  if (typeof window === 'undefined') return;
  window.recurly = createRecurlyMock();
};
